import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as e } from "../../../../IconBase-CxZyIWw2.js";
const n = t((s, r) => /* @__PURE__ */ o.jsx(
  e,
  {
    ref: r,
    ...s,
    image: (i) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...i,
        children: /* @__PURE__ */ o.jsx("path", { fill: "currentColor", d: "M1 7h14v2H1z" })
      }
    )
  }
));
n.displayName = "MinusIcon";
export {
  n as MinusIcon,
  n as default
};
//# sourceMappingURL=index.js.map
